import React from "react";
import Icon from "@ant-design/icons";

const StudentAddSvg = ({ width = "1rem", height = "1rem", fill = "none" }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox={`0 0 ${width} ${height}`}
		height={height}
		width={width}
		fill={fill}
	>
		<path
			d="M12 5V7M12 7V9M12 7H14M12 7H10M8.5 4.25C8.5 5.49264 7.49264 6.5 6.25 6.5C5.00736 6.5 4 5.49264 4 4.25C4 3.00736 5.00736 2 6.25 2C7.49264 2 8.5 3.00736 8.5 4.25ZM2.00061 12.8229C2.00021 12.7986 2 12.7743 2 12.75C2 10.4028 3.90279 8.5 6.25 8.5C8.59721 8.5 10.5 10.4028 10.5 12.75V12.7517C10.5 12.7755 10.4998 12.7992 10.4994 12.8229C9.25824 13.5702 7.80432 14 6.25 14C4.69568 14 3.24176 13.5702 2.00061 12.8229Z"
			stroke="#344054"
			strokeWidth="1.00352"
			strokeLinecap="round"
			strokeLinejoin="round"
			// stroke-width="1.00352"
			// stroke-linecap="round"
			// stroke-linejoin="round"
		/>
	</svg>
);
const StudentAddIcon = (props) => (
	<Icon component={() => <StudentAddSvg {...props} />} />
);

export default StudentAddIcon;
